import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  padding: 0 !important;

  .menu__button {
    position: relative;
    background: none;
    border: none;
    box-shadow: none;

    img {
      width: 14px;
    }

    &:hover {
      background: none;
    }

    ${(props) =>
      props.isOpen &&
      css`
        &:before {
          content: '';
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          width: 0px;
          height: 0px;
          border-style: solid;
          border-width: 0px 8px 8px;
          border-color: transparent transparent #2f3845;
        }
      `}
  }
`;

export const ContainerMenu = styled.div`
  position: absolute;
  background: #2f3845 0% 0% no-repeat padding-box;
  z-index: 12;
  backdrop-filter: blur(2px);
  border-radius: 10px;

  display: ${(props) => (props.isOpen ? 'flex' : 'none')};

  top: calc(100% + 8px);

  right: -40px;
  width: max-content;
  max-width: 280px;

  padding: 10px 5px !important;
`;

export const ContentMenu = styled.div`
  padding: 0px 10px !important;
  color: #fff;

  width: 100%;
  overflow-y: auto;
  max-height: 180px;

  h4 {
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 6px;
    text-align: left;
  }

  input {
    height: 22px;
    border-radius: 4px !important;
    font-weight: normal !important;
    font-size: 13px !important;
    color: #2f3845 !important;
    margin-bottom: 16px;
    width: 100%;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 13px;
      margin-bottom: 2px;
      font-weight: normal;
      cursor: pointer;
      word-break: break-word;
      text-align: left;
    }
  }
`;
